import { render, staticRenderFns } from "./vuetiform-checkboxes.vue?vue&type=template&id=10abf6fd&scoped=true&"
import script from "./vuetiform-checkboxes.vue?vue&type=script&lang=js&"
export * from "./vuetiform-checkboxes.vue?vue&type=script&lang=js&"
import style0 from "./vuetiform-checkboxes.vue?vue&type=style&index=0&id=10abf6fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../@vue-modules/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10abf6fd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../@vue-modules/vuetify/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
